import { Box, IconButton, styled } from "@material-ui/core";
import { CustomTheme } from "@orijinworks/frontend-commons";


export const RoundIconButton = styled(IconButton)(({ theme }) => ({
  color: CustomTheme.palette.primary.main,
  border: `1px solid ${CustomTheme.palette.primary.main}`,
  width: 40,
  height: 40,
}));

export const AuditHeader = styled(Box)(({ theme }) => ({
  borderBottom: `1px solid ${CustomTheme.palette.grey60.main}`,
}));

export const DataGridWrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  '& .tabl-container': {
    padding: '0px 30px'
  },

  '& div': {
    boxSizing: 'border-box',
  },
  '& > div:nth-child(2)': {
    padding: '0 25px',
  },
  '& > div:first-child': {
    padding: '10px 25px 40px'
  },
  '&.Announcements tbody td:nth-child(5), &.Conversations tbody td:nth-child(5)': {
    display: 'flex',
    alignItems: 'center',
    height: 55,
    overflow: 'hidden',
    padding: '15px 0px',
  },
  '&.Announcements tbody td:nth-child(5) div, &.Conversations tbody td:nth-child(5) div': {
    display: '-webkit-box',
    '-webkit-line-clamp': 2,
    '-webkit-box-orient': 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'normal',
    wordBreak: 'break-word',
    maxWidth: '100%',
  },
  '& tbody td:nth-child(6) .MuiAvatar-root': {
   fontWeight: 'bold',
  }
}));